// Native-digit localisation for numbers. Indian grouping (2,2,3) and ₹ are produced by the
// en-IN formatters upstream; here we only swap the digit glyphs to match the active language.
const DIGIT_MAPS = {
  hi: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"], // Devanagari
  mr: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
  gu: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"], // Gujarati
};

let LANG = "en";
try {
  LANG = localStorage.getItem("lang") || "en";
} catch {
  LANG = "en";
}

export function setNumeralLang(lang) {
  LANG = lang || "en";
}

// Convert ASCII digits in a formatted string to the active language's digits.
export function loc(str) {
  const map = DIGIT_MAPS[LANG];
  if (!map || str === null || str === undefined) return str;
  return String(str).replace(/[0-9]/g, (d) => map[+d]);
}
